export default {
  title: 'Liga de pago eliminada',
  message:
    'Esta liga de pago ha sido eliminada. Deberá ponerse en contacto con el negocio que le envió la liga.',
};
